import React from "react";

const DeleteChartModal = ({
  heading,
  chartType,
  onClose,
  onConfirm,
  isSubmitting,
}) => {
  const label =
    chartType === "bar"
      ? "Bar Chart"
      : chartType === "pie"
      ? "Pie Chart"
      : chartType === "progress"
      ? "Progress Chart"
      : chartType === "summary"
      ? "Summary"
      : "Chart";

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-slate-900/40 backdrop-blur-sm">
      <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl border border-slate-100 p-6">
        {/* Header */}
        <div className="flex items-start justify-between gap-3 mb-4">
          <div>
            <h2 className="text-base font-semibold text-slate-900">
              Delete {label} configuration
            </h2>
            <p className="mt-1 text-xs text-slate-500">
              Are you sure you want to delete this configuration? This action
              cannot be undone.
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-slate-100 text-slate-500 hover:bg-slate-200 text-sm"
            disabled={isSubmitting}
          >
            ✕
          </button>
        </div>

        {/* Body */}
        {heading && (
          <div className="mt-2 rounded-xl bg-slate-50 px-3 py-2 text-xs text-slate-700">
            <span className="font-semibold">Heading: </span>
            <span>{heading}</span>
          </div>
        )}

        {/* Actions */}
        <div className="mt-6 flex justify-end gap-2">
          <button
            type="button"
            className="rounded-xl border border-slate-200 bg-white px-4 py-1.5 text-xs font-medium text-slate-600 hover:bg-slate-50"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isSubmitting}
            className="rounded-xl bg-gradient-to-r from-rose-500 to-red-500 px-4 py-1.5 text-xs font-semibold text-white shadow-md hover:shadow-lg disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {isSubmitting ? "Deleting..." : "Yes, delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteChartModal;
